import React from "react";
import "./WesHeadContent.css";
const WesHeadContent = () => {
  return (
    <div className="WesHeadContent">
      <h1>
        WES Attestation and Verification Services in Bangalore:{" "}
        <span> Goodway Attestation</span>
      </h1>
      <p>
        World Education Services (WES) is an international non-profit
        organization dedicated to helping international students achieve their
        educational and professional goals. Each year, WES provides verification
        services to over 1.5 million students and professionals. WES
        verification is specifically required for the United States (US) and
        Canada (WES Canada). Once migrants receive WES accreditation, they can
        easily relocate to these Western countries. While WES verification is
        currently limited to the US and Canada, it is expected to become
        mandatory in other countries in the future. Verification from WES is
        essential for educational or academic certificates. The primary
        qualification needed for applying for WES verification is a Bachelor's
        Degree.
      </p>
    </div>
  );
};

export default WesHeadContent;
